import React from 'react';
import classes from './Product.module.scss';
import {Link, withRouter} from 'react-router-dom';
import ReactLoading from 'react-loading';
import {isIPad13, isMobileOnly, isTablet} from "react-device-detect";
import {FormattedMessage} from "react-intl";

// const HeroImage = React.lazy(() => import('./HeroImage/HeroImage'))
// const LoadableComponent = React.lazy(() => import('./ProductImage'));

const setSelectedProduct = (paramProduct) => {
    localStorage.setItem('selected_product_name', paramProduct.name)
    // alert( paramProduct.name );
}

const Product = (props) => {
    let stringBadge = '';
    if (props.prod) {
        if (props.prod.is_new_product !== null || props.prod.is_fav_product !== null) {
            if (+props.prod.is_new_product === 1) {
                stringBadge = <div className={["jbfs-badge-new", classes.Product_badge].join(' ')}><FormattedMessage id={"global.product.badge.new"} defaultMessage={"NEW"}/></div>
            } else if (+props.prod.is_fav_product === 1) {
                stringBadge = <div className={["jbfs-badge-fav", classes.Product_badge].join(' ')}><FormattedMessage id={"global.product.badge.fav"} defaultMessage={"FAV"}/></div>
            }
        } else {
            stringBadge = '';
        }
    }

    let ifIsdoneExist = props.done;
    if (!ifIsdoneExist) {
        ifIsdoneExist = true
    }

    return (
        <div className={[classes.Products_card].join(' ')}>
            <Link to={"/product-detail/" + props.prod.slug}
                  target={isMobileOnly || isIPad13 || isTablet ? "_self" : "_blank"} onClick={() => setSelectedProduct( props.prod )}>
                <div className={classes.CardHeader_row}
                    //onClick={() => gotoDetail(props.prod.slug)}
                    //onClick={() => props.gotoDetail(props.prod.slug)}
                >
                    {stringBadge}
                    {
                        !ifIsdoneExist ?
                            (<ReactLoading type={"bars"} color={"#FF6600"} className={"loading-margin"}/>)
                            :
                            (<div className={classes.CardHeader_image} style={{backgroundImage: `url(${props.prod.image_original})`}}/>)
                            // (<LoadableComponent hero_image={props.prod.image_original}/>)
                    }
                    {/* Request to take out title case/ 2020-01-sep 
                        <h3 className="jbfs-title-case">{props.prod.name.toLowerCase()}</h3> 
                    */}
                    <h3 className={[classes.Title_product, (props.prod.name.length > 35 ? classes.Title_more_3_lines : '')].join(' ')}>{props.prod.name}</h3>

                </div>

                <div className={classes.CardFooter_row}>
                    <div className={classes.CardFooter_wrapper}>
                        <div className={classes.CardFooter_brand}>
                            {props.prod.product_brand_image_icon ?
                                <img src={props.prod.product_brand_image_icon || ''} alt={props.prod.name}/> : ''}
                            <span className={classes.Brand_name}>{props.prod.product_brand_name || ''}</span>
                        </div>
                        <img className={classes.CardFooter_mascot}
                             src={props.prod.product_category_image_icon}
                             alt={props.prod.name || ''}/>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default withRouter(Product);